/**
 * Created by xinjundong on 2017/11/23.
 */
export const androidUrl = '//autoapp.auto.sohu.com/public/landing.html?from=huiliuye'
export const iosUrl = 'https://itunes.apple.com/app/apple-store/id631115095?pt=217229&ct=huiliuye&mt=8'
export const androidWXURL = '//a.app.qq.com/o/simple.jsp?pkgname=com.sohu.auto.sohuauto'



// WEBPACK FOOTER //
// ./src/api/utils/address.js